/**
 * Created by razial on 21.09.2026.
 */

const KrakenFeast = function (mission, isNewMission) {
    this.mission = mission;

    if (isNewMission) {
        const isFirstRun = !cleverapps.missionManager.getLastRemoved(mission.type);
        Map2dLocation.currentLocation.monstersPlanner.spawnToAllSlots(isFirstRun);
    }
};

KrakenFeast.prototype.stop = function () {
    if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && MissionManager.hasProperLocation(this.mission.type)) {
        Map2dLocation.currentLocation.monstersPlanner.stop();
        Map2dLocation.currentLocation.quests.applyDynamicFilter();
    }
};
